import { SectionError, SectionLoading } from '@/components/section-state';
import { TextPanel } from './DetailPanel';

interface SessionPreviewProps {
  isLoading: boolean;
  transcriptText: string;
  modelSummary?: string;
  userSummary?: string;
  isError: boolean;
  error: unknown;
  onRetry: () => void;
}

/**
 * What the selected session already contains: its transcript and the summaries
 * production stored for it. The originals are the baseline a reviewer compares
 * candidate output against, so absence of a summary means no panel — an empty
 * panel would read as "production produced nothing".
 */
export const SessionPreview = ({
  isLoading,
  transcriptText,
  modelSummary,
  userSummary,
  isError,
  error,
  onRetry,
}: SessionPreviewProps) => {
  if (isLoading) return <SectionLoading label="Sæki umritun" />;

  if (isError) return <SectionError title="Ekki tókst að sækja umritun" error={error} onRetry={onRetry} />;

  return (
    <div className="space-y-2">
      {transcriptText ? (
        <TextPanel label="Umritun" body={transcriptText} />
      ) : (
        <p className="text-muted-foreground text-sm">Engin umritun fannst fyrir þessa lotu.</p>
      )}
      {modelSummary && <TextPanel label="Upprunaleg samantekt (AI)" body={modelSummary} />}
      {userSummary && <TextPanel label="Samantekt læknis" body={userSummary} />}
    </div>
  );
};
